import * as React from 'react'

// libs
import { Portal } from 'react-portal';

// snippets
import DrawerInfo from '../Drawers/DrawerInfo'

// rsuite
import ToolsIcon from '@rsuite/icons/Tools';


export default function UiButton() {

  // refs
  const refDrawerInfo = React.useRef(null)

  // render
  const node = typeof document !== 'undefined' && document.getElementById('controls')

  return (
    <>
      <DrawerInfo ref={refDrawerInfo} />

      <Portal node={node}>
        <button onClick={() => refDrawerInfo.current.open()}>
          <ToolsIcon style={{
            fontSize: 24,
            lineHeight: 0,
          }} />
        </button>
      </Portal>
    </>

  )
}